import { render } from "./CashierAccount.vue?vue&type=template&id=66663ec1"
import script from "./CashierAccount.vue?vue&type=script&lang=js"
export * from "./CashierAccount.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__